import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SelectedOrders } from '@features/orders/models/selected-order';
import { Order } from '@features/orders/models/order.model';

@Component({
  selector: 'app-undetailed-orders-list',
  templateUrl: './undetailed-orders-list.component.html',
  styleUrls: ['./undetailed-orders-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UndetailedOrdersListComponent {
  @Input() orders: SelectedOrders[];
  @Input() ordersNo: number;
  @Input() itemsNo: number;
  @Input() palletsNo: number;
  @Output() selectOrder = new EventEmitter<{ order: Order; selectedPalletsCount: number; isAllSelected: boolean }>();
  @Output() selectAll = new EventEmitter();

  onSelectQuantity(order: SelectedOrders, quantity: number) {
    const selectedCount = (order.selectedPalletsCount || 0) + quantity;
    const isAllSelected = selectedCount === order.order.actualNoOfPallets;
    this.selectOrder.emit({
      order: order.order,
      selectedPalletsCount: quantity,
      isAllSelected,
    });
  }

  onSelectAll() {
    this.selectAll.emit(
      this.orders.map((order) =>
        Object.assign({}, order, {
          selectedPalletsCount: order.order.actualNoOfPallets,
          selected: true,
        })
      )
    );
  }
}
